<template>
    <div style="padding: 10px 20px;">
        <el-row>
            <el-col :span="24" style="text-align: left; padding-top: 30px;">
                <span class="mainTitle">
                    舟山辰熙新材料有限公司 简介
                </span>
            </el-col>
        </el-row>
        <el-row>
            <el-col :span="12"  style="text-align: left;padding:20px 60px;">
                <span  class="mainContent">
                    舟山辰熙新材料有限公司（简称辰熙新材料）成立于2021年，是一家专业的化工品及化工衍生品贸易分销公司，公司设在舟山。 舟山辰熙作为一个专业的化工品分销商，在行业内拥有良好声誉。主营聚醚多元醇、聚合物多元醇，表面活性剂、分散剂、催化剂、丙二醇、四氯乙烯等一系列产品，拥有专业化的营销团队、丰富的产品渠道和稳定的客户群体，提供全链条营销服务及解决方案，在汽车、家用电器、电子、通讯、医疗、食品、日用化工等领域具有较高的市场占有率。
<br>
<br>
<b>企业愿景：坚持“创新、绿色、共享、增长”的发展理念，提供创新、
优质、绿色的产品、服务和综合解决方案，致力于成为领先的创新型
新材料企业</b>

                </span>
                
            </el-col>
            <el-col :span="12"  style="text-align: left;padding:20px 60px;">
                <img src="../../../../assets/images/companyInfo.png" class="mainPic"/>
                
            </el-col>
        </el-row>
        <br>
        <br>
        <el-row>
            <el-col :span="24" class="mainProduct">
                产品及应用
            </el-col>
        </el-row>
        <el-row>
            <el-col :span="24">
                <el-carousel :interval="4000" type="card" height="400px">
                    <el-carousel-item v-for="item in 6" :key="item">
                    <h3 class="medium">
                        <el-image :src="require('../../../../assets/images/product/product_00' + + item + '.png')" class="mainPic" lazy/>
                    </h3>
                    </el-carousel-item>
                </el-carousel>
            </el-col>
        </el-row>
        <br>
        <br>
        <el-row>
            <el-col :span="24" class="mainProduct">
                行业动态
            </el-col>
        </el-row>
        <el-row>
            <el-col v-for="( item ) in mainProductDetail" :key="item.key" :span="10" :offset="1" style="padding: 0 30px  60px 30px;">
            <el-card :body-style="{ padding: '0px' }" style="">
                <el-image :src="item.img" alt="img" class="image" fit="contain" style="height: 100%; width: 100%;"/>
                <div style="padding: 14px">
                    <el-row>
                        <el-col :span="18" class="mainProductDetail_title">
                            {{ item.title }}
                        </el-col>
                        <el-col :span="6" class="mainProductDetail_entryDate">
                            {{ item.currentDate }}
                        </el-col>
                    </el-row>
                    <el-row>
                        <el-col :span="24" class="mainProductDetail_description">
                            {{ item.description }}
                        </el-col>
                    </el-row>
                </div>
            </el-card>
            </el-col>
        </el-row>
    </div>
</template>

<script>
import { v4 as uuidv4 } from 'uuid';
import api from '@/api/api'

export default {
    name: "cn_Home",
    components: {  },
    data() {
        return {
            mainProductDetail: [],
            productList:{}
        }
    },
    created(){
        this.initProductList();
    },
    mounted(){
        
    },
    methods:{
        async initProductList () {
            await this.getProductList();
            await this.handleProductShow();
        },
        async getProductList(){
            let data = {
                pageNo: 1,
                pageSize: 10,
                searchParameters: [
                    {
                        "field": "lang",
                        "op": 0,
                        "value": "zh"
                    }, 
                ]
            };
            let _res = await api.postNewsListD( data );
            this.productList = _res.data.data;
        },
        async handleProductShow () {
            const _resData = this.productList;
            _resData.rows.forEach( async (e, index ) => {
                if ( index < 6 ) {
                    this.mainProductDetail.push({
                        title:  e.title,
                        description: e.content,
                        img: await this.getImage( e.attchs[0] ),
                        key: uuidv4(),
                        currentDate: e.createdTime
                    })
                }
            });
        },
        async getImage( id ) {
            if (id) {
                let _tempRes = await api.getSysFileInfoPreview({id: id});
                if ( _tempRes.status === 200 ) {
                    return window.URL.createObjectURL(new Blob([_tempRes.data]));
                } else {
                    return '--';
                }
            } else {
                return "No Images"
            }
        },
    }
}
</script>

<style>
.image {
    width: 300px;
    height: 200px;
}
.mainProduct {
    margin-bottom: 20px;
    font-size: 36px;
}
.mainProductDetail_title {
    text-align: left;
    font-size: 28px;
    padding-left: 20px;
    padding-bottom: 20px;
}
.mainProductDetail_entryDate {
    text-align: right;
    font-size: 14px;
    color: darkgray;
}

.mainProductDetail_description {
    text-align: left;
    font-size: 14px;
    color: #333;
    line-height: 2em;
    padding: 0 10px;
}
</style>